import React, { useEffect, useState } from "react";
import AuthService from "../../Components/auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import Message from "../../Components/common/Message";
import { Table, Button, Flex, InputNumber, Modal, Input, Divider, Typography, message, Row, Col, DatePicker, Tooltip, Image, Tag, Checkbox } from "antd";
import { ArrowLeftOutlined, DeleteFilled, ExportOutlined, InfoCircleTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ScanInput from "../Scan/ScanInput";
import { useSelector } from "react-redux";
import { method } from "lodash";
import dayjs from "dayjs";
import moment from "moment";
import { env, wms_uploads_cdn } from "../../Components/config";
import ScanSelect from "../Scan/ScanSelect";
import { showMessage } from "../../Components/Utils/message";


const ReturnedStock = () => {
  const { locations, products } = useSelector((state) => state?.AppState?.userCreds);
  let layoutDispatch = useLoadingDispatch();
  const Auth = new AuthService();
  const navigate = useNavigate()
  const { Text } = Typography;
  const [loadMessage, setLoadMessage] = useState("");
  const [type, setType] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [creditNoteId, setCreditNoteId] = useState("");
  const [recievedData, setRecievedData] = useState([]);

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [returnedStock, setReturnedStock] = useState({
    product: "",
    product_id: '',
    location: "",
    location_id: null,
    quantity: "",
    productText: '',
    locationText: '',
    productStatus: null,
    locationStatus: null,
    expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    fullPallet: false
  });
  const [selectedProductLocations, setSelectedProductLocations] = useState([])
  

  const [stockTransactions, setStockTransactions] = useState([])
  const [posted, setPosted] = useState(false);


  const postStockData = async () => {
    showLoading(layoutDispatch);
    const dataToSend = {
      netsuite_transaction_id: creditNoteId,
    }
    try {
      const res = await Auth.fetch(`/stock/post-cn-stock`, {
        method: "POST",
        body: JSON.stringify(dataToSend)
      });
      if (res?.ack) {
        showMessage('success',res?.message);
        handleSearch()
        // navigate("/stocks");
      } else {
        showMessage('error',res?.message);
        hideLoading(layoutDispatch);
      }

    } catch (err) {
      console.log(err);
      showMessage('error','Something went wrong');
      hideLoading(layoutDispatch);

    }
    // finally {
    //   hideLoading(layoutDispatch);
    // }
  };

  const handleSelect = (record) => {
    setSelectedItem(record);
    console.log('record', record);

    setModalVisible(true);
  };

  const handleValueChange = (value, isScanned) => {
    setDocumentNumber(value);
    if (isScanned) {
      handleSearch();
    }
  };
  const productValueChange = (value) => {
    setReturnedStock({ ...returnedStock, product: value });
  };
  const locationValueChange = (value) => {
    setReturnedStock({ ...returnedStock, location: value });

  };

  const handleModalOk = async () => {
    const dataToSend = {
      product_netsuite_id: returnedStock?.product_id,
      location_id: returnedStock?.location_id,
      quantity: returnedStock?.quantity,
      document_number: documentNumber,
      netsuite_transaction_id: creditNoteId,
      expiry_date: returnedStock?.expiry_date ? moment(returnedStock?.expiry_date).format('YYYY-MM-DD') : null,
    };
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch('/stock/add-returned-stock', {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      });
      if (res?.ack) {
        showMessage('success',res?.message)
        setReturnedStock({ product: "", product_id: '', location: "", location_id: '', quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)) })
        setModalVisible(false);
        handleSearch()
      } else {
        showMessage('error',res?.message)
        hideLoading(layoutDispatch)

      }
    } catch (err) {
      console.log(err);
      showMessage('error','Something went wrong');
      hideLoading(layoutDispatch)

    }
    // finally {
    //   hideLoading(layoutDispatch)
    // }

  };

  const handleModalCancel = () => {
    setReturnedStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, expiry_date: new Date(new Date().setFullYear(new Date().getFullYear() + 1)) })
    setModalVisible(false);
  };


  const handleSearch = async (scanInputValue) => {
    setStockTransactions([])
    if (!documentNumber?.trim()) {
      handleError("Please enter the Document Number.");
      return;
    }

    showLoading(layoutDispatch);

    try {
      const response = await Auth.fetch(`/ns/get-credit-note?id=${encodeURIComponent(documentNumber)}`);
      hideLoading(layoutDispatch);

      if (response?.ack) {
        const allItems = response.order?.items
        // handleSuccess(response.order?.items ?? []);
        setPosted(response?.posted == true ? true : false);
        setCreditNoteId(response.order?.transactionId);
        await getNewStockQty(response.order?.transactionId, allItems)
        showMessage('success', response?.message)
      } else {
        // handleError("No data is available for this PO number");
        showMessage('error', response?.message)
      }
    } catch (error) {
      hideLoading(layoutDispatch);
      console.error("Error fetching purchase order:", error);
      // handleError("An error occurred while fetching the data. Please try again.");
      showMessage('error', 'something went wrong')
    }
  };

  const getNewStockQty = async (creditNoteId, allItems) => {
    if (!creditNoteId) {
      hideLoading(layoutDispatch)
      return;
    };
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/stock/get-new-stock?id=${creditNoteId}&transaction_type=${2}`);
      if (res?.ack) {
        console.log(res, 'Stock');
        if (res?.stock_txns.length > 0) {
          setStockTransactions(res?.stock_txns)

          const stockData = res.stock_txns.reduce((acc, stockItem) => {
            acc[stockItem.product_netsuite_id] = (acc[stockItem.product_netsuite_id] || 0) + stockItem.quantity;
            return acc;
          }, {});



          const updatedItems = allItems.map((item) => ({
            ...item,
            quantityAdded: stockData[Number(item.itemId)] || 0,
          }));
          setRecievedData(updatedItems ?? []);
        } else {
          const updatedItems = allItems.map((item) => ({
            ...item,
            quantityAdded: 0,
          }));
          setRecievedData(updatedItems ?? []);
        }

      }
    } catch (err) {
      console.log(err);
      showMessage('error','something went wrong')
    } finally {
      hideLoading(layoutDispatch)
    }
  }
  // const handleSuccess = (data) => {
  //   setRecievedData(data);
  //   setType("success");
  //   setLoadMessage("Data is available for this PO number.");
  // };

  const handleError = (message) => {
    setRecievedData([]);
    setType("error");
    setLoadMessage(message);
  };

  console.log(recievedData, 'recievedData');


  const dataCol = [
    {
    title: "Sr No.",
    render: (_, __, index) => <span>{index + 1}</span>,
    width: 60, 
  },
    {
      title: "Item",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.itemId);
        const files = item?.files ? JSON.parse(item?.files) : [];

        return (
          <Flex gap={5} align="center">
            <Tooltip title={'Product Info'}>

              <InfoCircleTwoTone style={{ fontSize: '16px', cursor: 'pointer' }} onClick={() => {
                Modal.info({
                  title: 'Product Info',
                  content: (
                    <div>
                      <p><strong>Item:</strong> {record?.itemName}</p>
                      {files?.length > 0 && <p><strong>Files</strong></p>}

                      <Image.PreviewGroup>
                        {files?.length > 0 &&
                          files?.map((item) => {
                            const encodedFileName = item.replace(/\+/g, '%2B');
                            const imageUrl = `${wms_uploads_cdn}/${env}/warehouse-products/${Number(record?.itemId)}/${encodedFileName}`;
                            return (
                              <>
                                <div
                                  style={{
                                    position: "relative",
                                    marginRight: "10px",
                                    display: "inline-block",
                                  }}
                                >
                                  <Image
                                    width={150}
                                    height={100}
                                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                                    src={imageUrl}
                                  />

                                </div>
                              </>
                            );
                          })}
                      </Image.PreviewGroup>
                    </div>
                  ),
                  onOk() { },
                  width: 600,
                  centered: true,
                  okText: 'Close',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  maskClosable: true,
                })
              }}
              />
            </Tooltip>
            <span>{record?.itemName}</span>

          </Flex>
        )

      }
    },
    {
      title: "Category",
      render: (record) => {
        const item = products?.find((item) => item.netsuite_id == record?.itemId);
        return (
          <span>{item?.category ? item?.category : '-'}</span>
        )
      }
    },
    {
      title: "Sub Category",
      render: (record) => {
        const item = products?.find((item) => item.netsuite_id == record?.itemId);
        return (
          <span>{item?.sub_category ? item?.sub_category : '-'}</span>
        )
      }
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity) => {
        return <span>{quantity?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: 'Quantity Received',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (quantity) => {
        return <span>{quantity?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: "Quantity Remaining",
      render: (record) => {
        return <span>{record?.quantity - record?.quantityAdded || '0'}</span>;
      },
    },
    {
      title: "Quantity Added",
      render: (record) => {
        return <span>{record?.quantityAdded?.toLocaleString() || '0'}</span>;
      },
    },
    // {
    //   title: "Action", align: "center", render: (record) => (
    //     <Button
    //       //  disabled={(record?.quantity - record?.quantityAdded) > 0 ? false : true} 
    //       type="primary" onClick={() => handleSelect(record)}>
    //       Select
    //     </Button>
    //   ),
    // },
    {
          title: "Action",
          align: "center",
          render: (record) => (
            <Tooltip title="Select Item">
              <ExportOutlined
                className="animated-select-icon"
                onClick={() => handleSelect(record)}
              />
            </Tooltip>
          ),
        }

  ];

  const isAnyQtyRemaining = (recievedData?.filter(
    (item) => (item?.quantity - item?.quantityAdded) > 0
  )?.length > 0) || false;

  console.log(isAnyQtyRemaining, 'isAnyQtyRemaining');


  const transactionCol = [
    {
      title: "Item",
      render(record) {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
        return (
          <Flex gap={5} align="center">
            <span>{item?.name}</span>
          </Flex>
        )
      }
    },
    {
      title: "Location",
      render(record) {
        const location = locations?.find((loc) => loc.id == record?.location_id);
        return (
          <Flex gap={5} align="center">
            <span>{location?.code}</span>
          </Flex>
        )
      }
    },
    {
      title: "Quantity",
      render(record) {
        return (
          <Flex gap={5} align="center">
            <span>{record?.quantity?.toLocaleString() || '0'}</span>
          </Flex>
        )
      }
    },
    {
      title: 'User',
      dataIndex: 'user_name',
      key: 'user_name',
    },
    {
      title: "Created At",
      render(record) {
        return (
          <Flex gap={5} align="center">
            <span>{record?.createdAt ? moment(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : null}</span>
          </Flex>
        )
      }
    },
    // {
    //   title: 'Action',
    //   align: "right",
    //   dataIndex: '',
    //   render(record) {
    //     return (
    //       <div style={{ display: "flex", justifyContent: "flex-end" }}>
    //         <DeleteFilled style={
    //           {
    //             fontSize: "25px",
    //             cursor: "pointer",
    //             color: "#cd1437",
    //           }} onClick={() => {
    //             Modal.confirm({
    //               title: 'Delete Transaction',
    //               centered: true,
    //               content: `Are you sure you want to delete this transaction?`,
    //               onOk: () => deleteTransaction(record.id),
    //               okText: 'Delete',
    //               cancelText: 'Cancel',
    //               width: 600,
    //               okButtonProps: { size: "large" },
    //               cancelButtonProps: { size: "large" },
    //             });
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
  ];

  if (!posted) {
    transactionCol.push({
      title: 'Action',
      align: "right",
      dataIndex: '',
      render(record) {
        return (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <DeleteFilled
              style={{
                fontSize: "25px",
                cursor: "pointer",
                color: "#cd1437",
              }}
              onClick={() => {
                Modal.confirm({
                  title: 'Delete Transaction',
                  centered: true,
                  content: `Are you sure you want to delete this transaction?`,
                  onOk: () => deleteTransaction(record.id),
                  okText: 'Delete',
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                });
              }}
            />
          </div>
        );
      },
    });
  }

  const deleteTransaction = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/stock/delete-transaction`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        showMessage('success',res?.message);
        setModalVisible(false);
        handleSearch();
      } else {
        showMessage('error',res?.message);
        hideLoading(layoutDispatch);
      }
    } catch (err) {
      console.log(err);
      showMessage('error',err?.message);
      hideLoading(layoutDispatch);
    }
    // finally {
    //   hideLoading(layoutDispatch);
    // }
  };



  const locationBlur = () => {
    if (!returnedStock?.product_id) {
      showMessage('error','Please select a product first')
      setReturnedStock({ ...returnedStock, location: '' })
      return;
    }
    const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id)
    const productLocations = selectedProduct?.product_locations
      ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
      : [];

    if (!returnedStock?.location) {
      setReturnedStock({ ...returnedStock, locationStatus: 'error', locationText: 'No Location Entered' })
      return;
    } else {
      const selectedLocation = locations?.find((loc) => loc?.code == returnedStock?.location)
      if (selectedLocation?.id && productLocations?.includes(selectedLocation?.id)) {
        setReturnedStock({ ...returnedStock, location_id: selectedLocation?.id, locationStatus: 'success', locationText: selectedLocation?.title })
      } else {
        setReturnedStock({ ...returnedStock, locationStatus: 'error', locationText: 'Location not found' })
      }

    }
  };

  const productBlur = () => {
    if (!returnedStock?.product) {
      setReturnedStock({ ...returnedStock, productStatus: 'error', productText: 'No Product Entered' })
      return;
    } else {
      const selectedProduct = products?.find((pro) => pro?.code == returnedStock?.product || pro?.barcode == returnedStock?.product);
        // get products locations array
        const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
      const matchedLocations = locations.filter(location =>
        productLocations.includes(location.id)
      );
      setSelectedProductLocations(matchedLocations);

      if (selectedProduct) {
        setReturnedStock({ ...returnedStock, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name })

      } else {
        setReturnedStock({ ...returnedStock, productStatus: 'error', productText: 'Product not found' })
      }
    }
  };

  const locationSelectValueChange = (val, isScanned) => {
      console.log('locationSelectValueChange', val, isScanned);
      if(!returnedStock?.product_id) {
        showMessage('error','Please select a product first')
        setReturnedStock({ ...returnedStock, location_id: null})
        return;
      }
      if (isScanned) {
        const matched = selectedProductLocations?.find(item => item.code === val);
      if (matched) {
        setReturnedStock({ ...returnedStock, location_id: matched.id });
      } else {
        showMessage('error',"No matching location ");
      }
      } else {
        setReturnedStock({ ...returnedStock, location_id: val });
      }
    };


  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h3 style={{ margin: 0 }}>Returned Stock</h3>
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</Button>
      </div>

      <>
        <Flex gap="small" wrap="wrap">
          <ScanInput onValueChange={handleValueChange} value={documentNumber} placeholder={'Search Document'} autoFocus={true} />
          <Button type="primary" onClick={handleSearch}>Search</Button>
        </Flex>

        {
          posted && (
            <Flex justify="end">
            <Tag color="red"  style={{ marginTop: "10px", fontSize: "16px", fontWeight: "bold" }}>
              Posted
            </Tag>
            </Flex>
          )
        }

        <div style={{ marginTop: "20px" }}>
          <Table
            columns={dataCol}
            dataSource={recievedData}
            pagination={false}
            scroll={{x: 'max-content'}}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          />
        </div>

        {
          recievedData?.length > 0 && (
            <Flex justify="end" gap={5} style={{ marginTop: "20px" }}>
          <Button type="primary" size="large" disabled={isAnyQtyRemaining || posted} onClick={postStockData}>Post</Button>
        </Flex>
          )
        }
        

        <Modal width={600} title={`New Stock Details for: ${documentNumber}`} open={modalVisible} onOk={handleModalOk} onCancel={handleModalCancel} okText="Save" okButtonProps={{ style: { display: posted && "none" } }}>
          <Divider />
          {
            Number(selectedItem?.quantity - selectedItem?.quantityAdded) > 0 && (
              <>
                <Row style={{ marginBottom: "10px" }}>
                  <Col>
                    <Text>Product</Text>
                    <Flex align="center" gap="small">
                      <ScanInput onValueChange={productValueChange} value={returnedStock?.product} placeholder="Product" size={'large'} onBlur={productBlur} />
                      <Text type={returnedStock.productStatus == "error" ? "danger" : returnedStock.productStatus == "success" ? "success" : ""}>
                        {returnedStock.productText}
                      </Text>
                    </Flex>
                  </Col>
                </Row>
                <Row style={{ marginBottom: "10px" }}>
                  {/* <Col>
                    <Text>Location</Text>
                    <Flex align="center" gap="small">
                      <ScanInput onValueChange={locationValueChange} value={returnedStock?.location} placeholder="Location" size={'large'} onBlur={locationBlur} />
                      <Text type={returnedStock.locationStatus == "error" ? "danger" : returnedStock.locationStatus == "success" ? "success" : ""}>
                        {returnedStock.locationText}
                      </Text>
                    </Flex>
                  </Col> */}
                  <Col >
                  <Text>Location</Text>
                  <ScanSelect onValueChange={locationSelectValueChange} value={returnedStock?.location_id} options={selectedProductLocations} placeholder="Location" size="large" length={'260px'} />
                  </Col>
                </Row>
                <Row >
                  <Col>
                    <Text>Quantity</Text>
                    <Flex align="center" gap="small">
                      <Input size="large" type='number' value={returnedStock?.quantity}
                        onChange={(e) => {
                          const newQty = e.target.value
                          if (e.target.value.includes('.')) return;
                          const remainingQty = selectedItem?.quantity - selectedItem?.quantityAdded;
                          if (newQty > remainingQty) {
                            showMessage('error','Quantity cannot be greater than remaining quantity')
                            return;
                          } else {
                            setReturnedStock({ ...returnedStock, quantity: newQty })
                          }
                          setReturnedStock({ ...returnedStock, quantity: newQty })

                        }
                        }
                        style={{ width: "290px" }} placeholder="Enter Quantity" />
                    </Flex>
                    <Checkbox
                  checked={returnedStock?.fullPallet}
                  size="large"
                  style={{ marginTop: "10px" }}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    if(isChecked){
                      if(!returnedStock?.product_id){
                        showMessage('error','Please select a product first');
                        return;
                      }
                      const selectedProduct = products?.find((pro)=> pro?.netsuite_id == returnedStock?.product_id);
                      console.log('selectedProduct', selectedItem);
                      
                      const qtyRemaing = selectedItem?.quantity - selectedItem?.quantityAdded;
                      const fullPalletQty = selectedProduct?.cases_in_pallets;
                      console.log('fullPalletQty', fullPalletQty, 'qtyRemaing', qtyRemaing);
                      
                      if(fullPalletQty > qtyRemaing) {
                        showMessage('error','Remaining quantity is less than pallet quantity')
                        return;
                      } else {
                        setReturnedStock({ ...returnedStock, quantity: fullPalletQty, fullPallet: e.target.checked })
                      } 
                    } else {
                      setReturnedStock({ ...returnedStock, quantity: '', fullPallet: false });
                    }
                    
                  }
                  }
                  >
                    Full Pallet
                  </Checkbox>

                  </Col>
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <Col>
                    <Text>Expiry Date</Text>
                    <br />
                    <DatePicker
                      format={'YYYY-MM-DD'}
                      style={{ width: '290px' }}
                      size="large"
                      value={returnedStock?.expiry_date ? dayjs(returnedStock?.expiry_date) : null}
                      onChange={(_, dateStr) => {
                        setReturnedStock({ ...returnedStock, expiry_date: dateStr })
                      }}
                      placeholder="Select Expiry Date"
                    />
                  </Col>
                </Row>
              </>
            )
          }
          {
            stockTransactions?.length > 0 &&
            (
              <>
                <h3 style={{ margin: 0 }}>Transactions</h3>
                <Table
                  columns={transactionCol}
                  dataSource={stockTransactions?.filter((item) => item?.product_netsuite_id == selectedItem?.itemId)}
                  pagination={false}
                  rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                  scroll={{ x:'max-content'}}
                />
              </>
            )
          }
        </Modal>
        <Message type={type} msg={loadMessage} />

      </>
    </>
  );
};

export default ReturnedStock;
